<template>
  <div v-if="!pageLoading" class="bg-[#FCFCFD]">
    <router-view></router-view>
  </div>
  <div v-else class="flex justify-center items-center p-10 h-screen w-screen">
    <div class="text-center flex flex-col justify-center items-center gap-y-6">
      <AppLoaderV2 />
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, provide } from "vue";
import { useStore } from "vuex";
import { setItem, getItem } from "@/utils/localStorageControl.js";
import { getSubApps, signUpWithMatta } from "@/services/userservices";
import cookieUtils from "@/utils/Cookies";
// eslint-disable-next-line no-unused-vars
import { AppCodes } from "@/utils/constants";
import AppLoaderV2 from "./components/AppLoaderV2.vue";

const pageLoading = ref(true);
const store = useStore();
const selectedApp = ref(getItem("selectedApp") ?? AppCodes.matta);

// ✅ Register user function with proper error handling
async function registerUser() {
  try {
    await signUpWithMatta({
      email: store?.getters.loggedUser?.email,
      appCode: selectedApp.value,
      ssoUserCategory: store?.getters.loggedUser?.userCategory,
      userType: 2,
    }).then((res) => {
      if (res.status === 200) {
        cookieUtils.set("agentId", res.data.data.agentId);
        cookieUtils.set("roles", res.data.data.roles);
      }
    });
  } catch (error) {
    console.error("Error registering user:", error);
  } finally {
    pageLoading.value = false;
  }
}

// ✅ Get data function optimized
async function getData() {
  const token = cookieUtils.get("token");
  if (!token) return;

  try {
    const res = await getSubApps();
    if (res.status === 200) {
      const appList = res.data.data.map((i) => ({
        ...i,
        url: i.url.replace("https://", "https://admin."),
        linkUrl: `${i.url.replace(
          "https://",
          "https://admin."
        )}/auth/validate?token=${token}`,
      }));
      setItem("appList", appList);
    }
  } catch (error) {
    console.error("Error fetching app data:", error);
  }
}

// ✅ Switch App function
function switchApp(value) {
  setItem("selectedApp", value);
  selectedApp.value = value;
}

// ✅ onBeforeMount with efficient checks
onBeforeMount(async () => {
  setItem("selectedApp", process.env.VUE_APP_MATTA_APP_CODE);
  const token = cookieUtils.get("token");
  if (!token) {
    pageLoading.value = false;
    return;
  }

  if (token) {
    await registerUser();
    await getData();
  }
});

// ✅ Provide global state
provide("selectedApp", selectedApp);
provide("switchApp", switchApp);
</script>

<style>
label,
.input-label {
  color: #344054 !important;
  font-size: 14px;
  margin-bottom: 6px;
}
</style>
